export default ".nomade-deactivator {\n  position: fixed;\n  bottom: 10px;\n  right: 10px;\n}"